<hx-loader *ngIf="isLoading.receipt" [isLoading]="true"></hx-loader>
<div class="check" *ngIf="checkList && checkList.length > 0 && isView && !isLoading.receipt">
  <div class="text-right m--margin-top-20 m--margin-bottom-10">
    <button (click)="printList()" class="btn btn-outline-info m-btn m-btn--icon btn-sm">
    <span>
      <i class="la la-print"></i>
      <span>{{ 'hx.order-receipt.printCheck' | transloco:{}:printLocale }}</span>
    </span>
    </button>
  </div>
  <div *ngFor="let check of checkList">
    <header class="check__header">
      <img [src]="check.logoUrl" alt="" width="150" class="check__logo">

      <div class="check__print-date" style="margin-right: -10px;">
        <strong>{{ 'hx.order-receipt.checkHidden' | transloco:{}:printLocale }}:</strong><br>
        <br>{{ check.printDate | date: 'dd.MM.yyyy HH:mm' }}
      </div>
    </header>

    <div class="print-check__info">
      <div *ngIf="check.organizationTitle && printLocale" class="print-check__info-line">
        {{ check.organizationTitle[printLocale] }}
      </div>

      <div *ngIf="check.organizationUin && printLocale" class="print-check__info-line">
        {{ check.uinName[printLocale] }}
        <span>{{ check.organizationUin }}</span>
      </div>

      <div *ngIf="check.fiscalDetails?.type === 'webkassa' && check.webkassa" class="print-check__info-line">
        <span class="m--margin-left-0" *ngIf="check.webkassa.taxSeries">{{ 'hx.order-receipt.series' | transloco:{}:printLocale }} {{ check.webkassa.taxSeries }}</span>
        <span *ngIf="check.webkassa.taxNumber">№ {{ check.webkassa.taxNumber }}</span>
      </div>
    </div>

    <div class="check__content">
      <div class="check__line">
        <strong>{{ 'hx.order-receipt.check' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">№{{ check.orderNumber }} <span *ngIf="isRefund(check)">({{ 'hx.order-receipt.return' | transloco:{}:printLocale }})</span></span>
      </div>

      <div class="check__line" *ngIf="isCashierVisible(check)">
        <strong>{{ 'hx.order-receipt.cashier' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ check.cashier | fio }}</span>
      </div>

      <div class="check__line" *ngIf="check.cancelReason">
        <strong>{{ 'hx.order-receipt.cancellation' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ check.cancelReason }}</span>
      </div>

      <div class="check__line" *ngIf="check.deliveryType === 'DELIVERY'">
        <strong>{{ 'hx.order-receipt.timeDelivery' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">
          {{ check.orderDate | date: 'dd.MM.yyyy' }}
          <ng-container *ngIf="check.deliveryRange; else timeRef">
            ({{ check.deliveryRange.fromTime | time }}-{{ check.deliveryRange.toTime | time  }})
          </ng-container>
          <ng-template #timeRef>
            ({{check.orderDate | date: 'HH:mm'}})
          </ng-template>
          <ng-container *ngIf="check.courierShortName">-{{ check.courierShortName }}</ng-container>
        </span>
      </div>

      <div class="check__line" *ngIf="check.deliveryType === 'PICKUP'">
        <strong>{{ 'hx.order-receipt.timePickup' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ check.orderDate | date: 'dd.MM.yyyy HH:mm' }}</span>
      </div>

      <div class="check__line" *ngIf="check.clientPhone">
        <strong>{{ 'hx.order-receipt.client' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ clientInfo(check) }}</span>
      </div>

      <div class="check__line" *ngIf="check.recipientPhone">
        <strong>{{ 'hx.order-receipt.user' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ recipientInfo(check) }}</span>
      </div>

      <div class="check__line" *ngIf="check.deliveryType === 'DELIVERY'">
        <strong>{{ 'hx.order-receipt.address' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ check.address }}</span>
      </div>

      <div class="check__line" *ngIf="printNote && check.note">
        <strong>{{ 'hx.order-receipt.note' | transloco:{}:printLocale }}:</strong>
        <span class="check__value">{{ check.note }}</span>
      </div>

      <table class="check__table">
        <thead>
        <tr>
          <td>{{ 'hx.order-receipt.table.head.name' | transloco:{}:printLocale }}</td>
          <td class="text-center text-nowrap">{{ 'hx.order-receipt.table.head.weight' | transloco:{}:printLocale }}</td>
          <td class="text-center text-nowrap">{{ 'hx.order-receipt.table.head.num' | transloco:{}:printLocale }}</td>
          <td class="text-right text-nowrap">{{ 'hx.order-receipt.table.head.sum' | transloco:{}:printLocale }}</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let product of check.products">
          <td style="max-width: 150px;word-wrap: break-word;">
            {{ product.title | uiLabel }}
            <span *ngIf="product.priceAmount !== 1">{{ product.priceAmount }}</span>
          </td>
          <td class="text-center text-nowrap">
            {{ product.weight | weight }}
          </td>
          <td class="text-center text-nowrap">
            {{ product.amount }}
          </td>
          <td class="text-right text-nowrap">
            {{ product.value?.toLocaleString('ru-RU') }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ 'hx.order-receipt.table.body.total' | transloco:{}:printLocale }}:</strong>
          </td>
          <td class="text-center"></td>
          <td class="text-center"></td>
          <td class="text-right text-nowrap">
            <strong>{{ check.subTotal?.toLocaleString('ru-RU') }}</strong>
          </td>
        </tr>

        <tr *ngIf="check.discounts?.length">
          <td colspan="5">
            <strong>{{ 'hx.order-receipt.table.body.discount' | transloco:{}:printLocale }}:</strong>
          </td>
        </tr>

        <tr *ngFor="let discount of check.discounts">
          <ng-container *ngIf="discount.enabled">
            <td class="m--padding-left-5">
              {{ discount.promoTitle | uiLabel }}
            </td>
            <td class="text-center">
            </td>
            <td class="text-center">
              {{ discount.productAmount }}
            </td>
            <td class="text-right text-nowrap">
              {{ discount | discountUoM: check.currency }}
            </td>
          </ng-container>
        </tr>
        <tr class="check__total" *ngIf="check.total">
          <td>
            <strong>{{ 'hx.order-receipt.table.body.totalAll' | transloco:{}:printLocale }}:</strong>
          </td>
          <td>
          </td>
          <td>
          </td>
          <td class="text-right text-nowrap">
            <strong>{{ check.total?.toLocaleString('ru-RU') }} {{currencySymbol}}</strong>
          </td>
        </tr>
        <tr *ngIf="check.total > 0 && check.webkassa?.taxType === 'VAT'">
          <td>
            {{ 'hx.order-receipt.table.body.text' | transloco:{}:printLocale }}
          </td>
          <td class="text-center">
          </td>
          <td class="text-center">
          </td>
          <td class="text-right text-nowrap">
            {{ check.total | vat:12 }} {{currencySymbol}}
          </td>
        </tr>
        <tr *ngIf="check.fiscalDetails?.type === 'atol' && check.atol">
          <td>
            {{ 'hx.order-receipt.vat-amount' | transloco }}
          </td>
          <td></td>
          <td></td>
          <td class="text-right text-nowrap">
            {{ check.total | vat:5 }} {{currencySymbol}}
          </td>
        </tr>
        </tbody>
      </table>

      <div *ngIf="check.paid">
        <strong>{{ 'hx.order-receipt.paidMethod' | transloco:{}:printLocale }}:</strong>

        <div *ngFor="let pt of check.payments" class="check__paymentType">
          {{'paymentType.' + pt.type | transloco:{}:printLocale}} <strong>{{ (pt.value)?.toLocaleString('ru-RU') }} {{currencySymbol}}</strong>
        </div>
      </div>

      <!-- WEBKASSA fiscal details -->
      <ng-container *ngIf="check.fiscalDetails?.type === 'webkassa' && check.webkassa">
        <div class="print-check-wk">
          <div class="print-col">
            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.fiscalCheck' | transloco:{}:printLocale }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.wkFiscalNumber' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.fiscalNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.wkCashboxIdentificationNumber' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.webkassa.cashboxIdentificationNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.wkCashboxFactoryNumber' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.webkassa.cashboxFactoryNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.wkCashboxRegistrationNumber' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.webkassa.cashboxRegistrationNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.wkFiscalDate' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.fiscalDate | date: 'dd.MM.yyyy HH:mm': check.storeTimezone }}</span>
            </div>
          </div>

          <div *ngIf="check.payQR" class="check-qr">
            <img [src]="check.payQR" alt="">
          </div>

          <div *ngIf="check.fiscalQR" class="print-col fiscal-qr" style="float: right; margin-top: 10px;">
            <img [src]="check.fiscalQR" alt="">
          </div>
        </div>

        <div class="print-check__info" *ngIf="check.offlineMode">
          <div class="print-check__offline_mode">
            <div>{{ 'hx.receipt.offlineMode' | transloco:{}:printLocale }}</div>
          </div>
        </div>

        <div class="print-check__info">
          <div class="print-check__ofd_verifier" *ngIf="check.ofdName && check.ofdHost">
            <div>{{ 'hx.order-receipt.ofd' | transloco:{}:printLocale }} {{ check.ofdName }} {{ 'hx.order-receipt.checkSite' | transloco:{}:printLocale }}: {{ check.ofdHost }}</div>
          </div>
        </div>
      </ng-container>

      <!-- ATOL fiscal details -->
      <ng-container *ngIf="check.fiscalDetails?.type === 'atol' && check.atol">
        <div class="print-check-wk">
          <div class="print-col">
            <div class="check__line">
              <span class="check__label">{{ 'hx.receipt.fiscalization' | transloco:{}:printLocale }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-1' | transloco:{}:printLocale }}:</span>
              <!-- серийный номер кассы -->
              <span class="check__value">{{check.atol.serialNumber}}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-2' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.registrationNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-3' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fnNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-4' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fiscalDocumentNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-5' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fiscalDocumentSign }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-6' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fiscalReceiptNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-7' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fiscalDocumentDateTime | date: 'dd.MM.yyyy HH:mm': check.storeTimezone }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-8' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.shiftNumber }}</span>
            </div>

            <div class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-9' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ check.atol.fnsUrl }}</span>
            </div>

            <div *ngIf="check.atol?.taxationType" class="check__line">
              <span class="check__label">{{ 'hx.order-receipt.text-11' | transloco:{}:printLocale }}:</span>
              <span class="check__value">{{ 'hx.atol.taxationType.' + check.atol.taxationType | transloco:{}:printLocale }}</span>
            </div>
          </div>

          <div *ngIf="check.payQR" class="check-qr">
            <img [src]="check.payQR" alt="">
          </div>

          <div *ngIf="check.fiscalQR" class="print-col fiscal-qr" style="float: right; margin-top: 10px;">
            <img [src]="check.fiscalQR" alt="">
          </div>
        </div>

        <div class="print-check__info">
          <div class="print-check__ofd_verifier" *ngIf="check.ofdName && check.ofdHost">
            <div>{{ 'hx.order-receipt.ofd' | transloco:{}:printLocale }} {{ check.ofdName }} {{ 'hx.order-receipt.checkSite' | transloco:{}:printLocale }}: {{ check.ofdHost }}</div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="check__footer">
      <div class="check__contacts">
        <div class="check__info">
          {{ check.storeAddress }}
        </div>

        <div class="check__info">Call-Center {{ check.callCenterPhones?.join(', ') }}</div>

        <div class="check__title">{{ 'hx.order-receipt.thanks' | transloco:{}:printLocale }}</div>
      </div>

      <div class="check__copyright m--margin-bottom-10">
       {{ 'hx.order-receipt.footer' | transloco:{}:printLocale }}
      </div>
    </div>

    <div *ngIf="check.withoutReceipt" class="check__without_receipt">
      {{ 'hx.order-receipt.noCheck' | transloco:{}:printLocale }}
    </div>
  </div>
  <div class="text-right m--margin-top-20 m--margin-bottom-10">
    <button (click)="printList()" class="btn btn-outline-info m-btn m-btn--icon btn-sm">
    <span>
      <i class="la la-print"></i>
      <span>{{ 'hx.order-receipt.printCheck' | transloco:{}:printLocale }}</span>
    </span>
    </button>
  </div>
</div>
<ng-container *ngFor="let page of timesToPrintList">
<div id="print-body" *ngIf="checkList && checkList.length > 0 && !isView">
  <div class="print-check" *ngFor="let check of checkList">
    <div class="print-check__container">
      <header class="print-check__header">
        <img [src]="check.logoUrl" alt="" width="110" class="print-check__logo">

        <div class="print-check__print-date">
          <span>{{ 'hx.order-receipt.printedCheck' | transloco:{}:printLocale }}:</span>
          <br> {{ check.printDate | date: 'dd.MM.yyyy HH:mm' }}
          <br> {{ check.printman }}
        </div>
      </header>

      <div class="print-check__info">
        <div *ngIf="check.organizationTitle && printLocale" class="print-check__info-line">
          {{ check.organizationTitle[printLocale] }}
        </div>

        <div *ngIf="check.organizationUin && printLocale" class="print-check__info-line">
          {{ check.uinName[printLocale] }}
          <span>{{ check.organizationUin }}</span>
        </div>

        <div *ngIf="check.fiscalDetails?.type === 'webkassa' && check.webkassa" class="print-check__info-line">
          <span *ngIf="check.webkassa.taxSeries" class="m--margin-left-0">{{ 'hx.order-receipt.text-10' | transloco:{}:printLocale }} {{ check.webkassa.taxSeries }}</span>
          <span *ngIf="check.webkassa.taxNumber">№ {{ check.webkassa.taxNumber }}</span>
        </div>
      </div>

      <div class="print-check__contacts m--margin-bottom-5">
        <div class="check__line">
          <strong>{{ 'hx.order-receipt.check' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">№{{ check.orderNumber }} <span *ngIf="isRefund(check)">({{ 'hx.order-receipt.return' | transloco:{}:printLocale }})</span></span>
        </div>

        <div class="check__line" *ngIf="isCashierVisible(check)">
          <strong>{{ 'hx.order-receipt.cashier' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ check.cashier | fio }}</span>
        </div>

        <div class="check__line" *ngIf="check.cancelReason">
          <strong>{{ 'hx.order-receipt.cancellation' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ check.cancelReason }}</span>
        </div>

        <div class="check__line" *ngIf="check.deliveryType === 'DELIVERY'">
          <strong>{{ 'hx.order-receipt.timeDelivery' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">
            {{ check.orderDate | date: 'dd.MM.yyyy' }}
            <ng-container *ngIf="check.deliveryRange; else timeRef">
              ({{ check.deliveryRange.fromTime | time }}-{{ check.deliveryRange.toTime | time  }})
            </ng-container>
            <ng-template #timeRef>
              ({{check.orderDate | date: 'HH:mm'}})
            </ng-template>
            <span [ngbTooltip]="'hx.order-receipt.ng.courier' | transloco:{}:printLocale" *ngIf="check.courierShortName">{{ check.courierShortName }}</span>
          </span>
        </div>

        <div class="check__line" *ngIf="check.deliveryType === 'PICKUP'">
          <strong>{{ 'hx.order-receipt.timePickup' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ check.orderDate | date: 'dd.MM.yyyy HH:mm' }}</span>
        </div>

        <div class="check__line" *ngIf="check.clientPhone">
          <strong>{{ 'hx.order-receipt.client' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ clientInfo(check) }}</span>
        </div>

        <div class="check__line" *ngIf="check.recipientPhone">
          <strong>{{ 'hx.order-receipt.user' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ recipientInfo(check) }}</span>
        </div>

        <div class="check__line" *ngIf="check.deliveryType === 'DELIVERY'">
          <strong>{{ 'hx.order-receipt.address' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{check.address}}</span>
        </div>

        <div class="check__line" *ngIf="printNote && check.note">
          <strong>{{ 'hx.order-receipt.note' | transloco:{}:printLocale }}:</strong>
          <span class="check__value">{{ check.note }}</span>
        </div>
      </div>

      <table class="print-check__table">
        <thead>
        <tr>
          <td>{{ 'hx.order-receipt.table.head.name' | transloco:{}:printLocale }}</td>
          <td class="text-center text-nowrap">{{ 'hx.order-receipt.table.head.weight' | transloco:{}:printLocale }}</td>
          <td class="text-center text-nowrap">{{ 'hx.order-receipt.table.head.num' | transloco:{}:printLocale }}</td>
          <td class="text-right text-nowrap">{{ 'hx.order-receipt.table.head.sum' | transloco:{}:printLocale }}</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let product of check.products">
          <td style="max-width: 150px;word-wrap: break-word;">
            {{ product.title | uiLabel }} <span *ngIf="product.priceAmount !== 1">{{ product.priceAmount }}</span>
          </td>

          <td class="text-center text-nowrap">
            {{ product.weight | weight }}
          </td>

          <td class="text-center text-nowrap">
            {{ product.amount }}
          </td>

          <td class="text-right text-nowrap">
            {{ product.value?.toLocaleString('ru-RU') }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ 'hx.order-receipt.table.body.total' | transloco:{}:printLocale }}:</strong>
          </td>
          <td class="text-center"></td>
          <td class="text-center"></td>
          <td class="text-right">
            <strong>{{ check.subTotal?.toLocaleString('ru-RU') }} {{currencySymbol}}</strong>
          </td>
        </tr>

        <tr *ngIf="check.discounts?.length">
          <td colspan="5">{{ 'hx.order-receipt.table.body.discount' | transloco:{}:printLocale }}:</td>
        </tr>

        <tr *ngFor="let discount of check.discounts">
          <ng-container *ngIf="discount.enabled">
            <td class="m--padding-left-5">
              {{ discount.promoTitle | uiLabel }}
            </td>
            <td class="text-center">
            </td>
            <td class="text-center">
              {{ discount.productAmount }}
            </td>
            <td class="text-right text-nowrap">
              {{ discount | discountUoM: check.currency }}
            </td>
          </ng-container>
        </tr>

        <tr *ngIf="check.total">
          <td>
            <strong>{{ 'hx.order-receipt.table.body.totalAll' | transloco:{}:printLocale }}:</strong>
          </td>
          <td>
          </td>
          <td>
          </td>
          <td class="text-right text-nowrap">
            <strong>{{ check.total?.toLocaleString('ru-RU') }} {{currencySymbol}}</strong>
          </td>
        </tr>
        <tr *ngIf="check.total && check.webkassa?.taxType === 'VAT'">
          <td>
            {{ 'hx.order-receipt.table.body.text' | transloco:{}:printLocale }}
          </td>
          <td class="text-center">
          </td>
          <td class="text-center">
          </td>
          <td class="text-right text-nowrap">
            {{ getVAT(check.total) }} {{currencySymbol}}
          </td>
        </tr>
        <tr *ngIf="check.fiscalDetails?.type === 'atol' && check.atol">
          <td>
            {{ 'hx.order-receipt.vat-amount' | transloco }}
          </td>
          <td></td>
          <td></td>
          <td class="text-right text-nowrap">
            {{ check.total | vat:5 }} {{currencySymbol}}
          </td>
        </tr>
        </tbody>
      </table>

      <div class="check-qr" *ngIf="check.payQR">
        <img [src]="check.payQR" alt="">
      </div>

      <div *ngIf="check.paid" class="print-check__payment-wrap">
        <span class="print-check__subtitle">
          {{ 'hx.order-receipt.paidMethod' | transloco:{}:printLocale }}:
        </span>

        <div *ngFor="let pt of check.payments" class="print-check__payment">
          <span>{{'paymentType.' + pt.type | transloco:{}:printLocale}}</span>
          <span>{{ (pt.value)?.toLocaleString('ru-RU') }} {{currencySymbol}}</span>
        </div>
      </div>

      <ng-container *ngIf="check.fiscalDetails?.type === 'webkassa' && check.webkassa">
        <div class="print-check-wk">
          <div class="print-check__info print-col">
            <div class="print-check__info-line">
              {{ 'hx.receipt.fiscalCheck' | transloco:{}:printLocale }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.receipt.wkFiscalNumber' | transloco:{}:printLocale }}: {{ check.fiscalNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.receipt.wkCashboxIdentificationNumber' | transloco:{}:printLocale }}: {{ check.webkassa.cashboxIdentificationNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.receipt.wkCashboxFactoryNumber' | transloco:{}:printLocale }}: {{ check.webkassa.cashboxFactoryNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.receipt.wkCashboxRegistrationNumber' | transloco:{}:printLocale }}: {{ check.webkassa.cashboxRegistrationNumber }}
            </div>

            <div class="print-check__info-line">
              {{'hx.receipt.wkFiscalDate' | transloco:{}:printLocale}}: {{ check.fiscalDate | date: 'dd.MM.yyyy HH:mm': check.storeTimezone }}
            </div>
          </div>

          <div *ngIf="check.payQR" class="check-qr">
            <img [src]="check.payQR" alt="">
          </div>

          <div *ngIf="check.fiscalQR" class="print-col fiscal-qr" style="float:right;">
            <img [src]="check.fiscalQR" alt="">
          </div>
        </div>

        <div class="print-check__offline_mode" *ngIf="check.offlineMode">
          <div>{{ 'hx.receipt.offlineMode' | transloco:{}:printLocale }}</div>
        </div>

        <div class="print-check__info">
          <div class="print-check__ofd_verifier">
            <div>{{ 'hx.order-receipt.ofd' | transloco:{}:printLocale }} {{ check.ofdName }} {{ 'hx.order-receipt.checkSite' | transloco:{}:printLocale }}: {{ check.ofdHost }}</div>
          </div>
        </div>
      </ng-container>

      <!-- ATOL fiscal details -->
      <ng-container *ngIf="check.fiscalDetails?.type === 'atol' && check.atol">
        <div class="print-check-wk">
          <div class="print-check__info print-col">
            <div class="print-check__info-line">
              {{ 'hx.receipt.fiscalization' | transloco:{}:printLocale }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-1' | transloco:{}:printLocale }}: {{check.atol.serialNumber}}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-2' | transloco:{}:printLocale }}: {{ check.atol.registrationNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-3' | transloco:{}:printLocale }}: {{ check.atol.fnNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-4' | transloco:{}:printLocale }}: {{ check.atol.fiscalDocumentNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-5' | transloco:{}:printLocale }}: {{ check.atol.fiscalDocumentSign }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-6' | transloco:{}:printLocale }}: {{ check.atol.fiscalReceiptNumber }} {{ 'hx.order-receipt.text-8' | transloco:{}:printLocale }}: {{ check.atol.shiftNumber }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-7' | transloco:{}:printLocale }}: {{ check.atol.fiscalDocumentDateTime | date: 'dd.MM.yyyy HH:mm': check.storeTimezone }}
            </div>

            <div class="print-check__info-line">
              {{ 'hx.order-receipt.text-9' | transloco:{}:printLocale }}: {{ check.atol.fnsUrl }}
            </div>

            <div *ngIf="check.atol?.taxationType" class="print-check__info-line">
              {{ 'hx.order-receipt.text-11' | transloco:{}:printLocale }}: {{ 'hx.atol.taxationType.' + check.atol.taxationType | transloco:{}:printLocale }}
            </div>
          </div>

          <div *ngIf="check.payQR" class="check-qr">
            <img [src]="check.payQR" alt="">
          </div>

          <div *ngIf="check.fiscalQR" class="print-col fiscal-qr" style="float: right; margin-top: 10px;">
            <img [src]="check.fiscalQR" alt="">
          </div>
        </div>

        <div class="print-check__info">
          <div class="print-check__ofd_verifier">
            <div>{{ check.ofdVerifierInfo }}</div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="check__footer">
      <div class="check__contacts">
        <div class="check__info">
          {{ check.storeAddress }}
        </div>

        <div class="check__info">Call-Center {{ check.callCenterPhones?.join(', ') }}</div>
        <div class="check__title">{{ 'hx.order-receipt.paid' | transloco:{}:printLocale }}</div>
      </div>

      <div class="check__copyright m--margin-bottom-10">
        {{ 'hx.order-receipt.footer' | transloco:{}:printLocale }}
      </div>
    </div>

    <div *ngIf="check.withoutReceipt" class="check__without_receipt">
      {{ 'hx.order-receipt.noCheck' | transloco:{}:printLocale }}
    </div>
  </div>
</div>
</ng-container>
